import { callPostApi, callDeleteApi, callPutApi } from "./api";

export async function getRecipeRawMaterial(data) {
      try {
            const response = await callPostApi({ url: "product-recipe/raw-materials/list", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}
export async function deleteRawMaterial(id) {
      try {
            const response = await callDeleteApi({ url: "product-recipe/raw-materials/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}
export async function recipeTypeList(data) {
      try {
            const response = await callPostApi({ url: "product-recipe/types/list", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}
export async function addRawMaterial(data) {
      try {
            const response = await callPostApi({ url: "product-recipe/raw-materials", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}
export async function updateRawMaterial(id, data) {
      try {
            const response = await callPutApi({ url: "product-recipe/raw-materials/" + id, body: data });
            return response;
      } catch (error) {
            throw error;
      }
}
export async function addUnit(data) {
      try {
            const response = await callPostApi({ url: "product-recipe/units", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}
export async function unitList(data) {
      try {
            const response = await callPostApi({ url: "product-recipe/units/list", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}
export async function unitDeleteData(id) {
      try {
            const response = await callDeleteApi({ url: "product-recipe/units/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}
export async function unitUpdate(id, data) {
      try {
            const response = await callPutApi({ url: "product-recipe/units/" + id, body: data });
            return response;
      } catch (error) {
            throw error;
      }
}
export async function addType(data) {
      try {
            const response = await callPostApi({ url: "product-recipe/types", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}
export async function typeList(data) {
      try {
            const response = await callPostApi({ url: "product-recipe/types/list", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}
export async function typeDeleteData(id) {
      try {
            const response = await callDeleteApi({ url: "product-recipe/types/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}
export async function typeUpdate(id, data) {
      try {
            const response = await callPutApi({ url: "product-recipe/types/" + id, body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function updateWholeSalePrice(id,data){
      try {
            const response = await callPutApi({ url: `product-recipe/raw-materials/update-whole-sale-price/${id}`, body: data });
            return response;
      } catch (error) {
            throw error; 
      }
}

export async function updateRetailPrice(id,data){
      try {
            const response = await callPutApi({ url: `product-recipe/raw-materials/update-retail-price/${id}`, body: data });
            return response;
      } catch (error) {
            throw error; 
      }
}